import {useCallback} from 'react';
import {useAppSelector} from "../../../redux/hooks";
import {
  getIsMySongsPageFilterDifficultyIdSelected
} from "../../../pages/songs-router/modules/my-songs-page-store/mySongsPage.selectors";
import {mySongsPageStore} from "../../../pages/songs-router/modules/my-songs-page-store/mySongsPage.store";
import {mySongsFiltersStore} from "../../../pages/songs-router/modules/my-songs-filters-store/mySongsFiltersStore";

export interface IFilterDifficultySubcategoryLogic {
  title?: string;
  isSelected: boolean;
  handleToggleOnClick: () => void;
}

const getMySongsFiltersDifficultySubcategoryTitleByDifficultyId = (difficultyId: number): string | undefined =>
{
  const {subcategoryId} = mySongsFiltersStore.getDifficultyById(difficultyId) ?? {};

  if (subcategoryId == undefined) {
    return undefined;
  }

  return mySongsFiltersStore.getDifficultySubcategoryFromId(subcategoryId)?.name;
}

export const useFilterDifficultySubcategoryLogic = (difficultyId: number): IFilterDifficultySubcategoryLogic => {
  const title = useAppSelector(() => getMySongsFiltersDifficultySubcategoryTitleByDifficultyId(difficultyId))
  const isSelected = useAppSelector((store) => getIsMySongsPageFilterDifficultyIdSelected(store, difficultyId));
  const handleToggleOnClick = useCallback(() => {
    mySongsPageStore.toggleFilterDifficultyById(difficultyId);
  }, [difficultyId])
  return {
    title,
    isSelected,
    handleToggleOnClick,
  };
}
